export default "__VITE_ASSET__CTHsgb9H__"